import axios from 'axios'

/**
 * Exported so the one place that still needs a fallback uses this wording rather
 * than its own copy of it. The Google half of this callback has no actionable
 * backend message to show and renders it directly.
 */
export const GENERIC_PLAID_OAUTH_ERROR = "We couldn't complete the connection."

/** Preserve actionable backend errors without exposing arbitrary thrown values. */
export const plaidOAuthErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error) && error.response?.data?.error) {
    return String(error.response.data.error)
  }
  if (error instanceof Error && error.message.startsWith('Signed-in account changed.')) {
    return error.message
  }
  return GENERIC_PLAID_OAUTH_ERROR
}
